import { render } from "./Title.vue?vue&type=template&id=6ebb2e67&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=6ebb2e67&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6ebb2e67"

export default script